
import React from "react";
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'

const faqs = [
  {
    "question": "Qu'est-ce qu'une convention de PACS chez le notaire ?",
    "answer": "La convention de PACS chez le notaire est un acte juridique qui officialise le pacte civil de solidarité entre deux personnes.\n\nElle est rédigée par un notaire pour garantir sa validité, sa sécurité juridique, et adapter ses clauses aux besoins spécifiques des partenaires."
  },
  {
    "question": "Pourquoi faire appel à un notaire pour son PACS ?",
    "answer": "Faire appel à un notaire permet de bénéficier d'un accompagnement personnalisé, de conseils juridiques avisés et d'une convention adaptée à la situation patrimoniale des partenaires.\n\nLe notaire assure également la conservation de l'acte et sa pleine valeur juridique."
  },
  {
    "question": "Quelles sont les clauses que l'on peut intégrer dans une convention de PACS ?",
    "answer": "La convention peut contenir des clauses sur :\n• Le régime patrimonial (séparation ou indivision).\n• La répartition des dépenses communes.\n• La gestion des biens communs ou personnels.\n• La protection en cas de séparation ou de décès.\n\nLe notaire peut également ajouter des clauses spécifiques selon vos besoins."
  },
  {
    "question": "Combien coûte une convention de PACS chez le notaire ?",
    "answer": "Le coût est réglementé :\n• Honoraires de rédaction d'environ 150€ HT.\n• Frais d'enregistrement autour de 25 €.\n\nLe prix peut légèrement varier selon la complexité du dossier ou si des actes complémentaires sont nécessaires."
  },
  {
    "question": "Quels documents faut-il fournir pour un PACS chez le notaire ?",
    "answer": "Il faut généralement fournir :\n• Une pièce d'identité valide pour chaque partenaire.\n• Un acte de naissance récent (moins de 3 mois).\n• Un justificatif de domicile.\n\nD'autres documents peuvent être requis en fonction de la situation personnelle ou patrimoniale."
  },
  {
    "question": "Quel est le délai pour conclure un PACS chez le notaire ?",
    "answer": "Chez Clotere les délais sont rapides :\n• Premier rendez-vous gratuite avec votre notaire sous quelques hours.\n• Rédaction et signature sous quelques jours après fourniture des pièces.\n\nLe notaire s’occupe de toutes les formalités administratives, dont l’enregistrement au greffe."
  },
  {
    "question": "Peut-on modifier une convention de PACS ?",
    "answer": "Oui, une convention de PACS est modifiable à tout moment.\n\nLes partenaires peuvent changer leur régime patrimonial ou ajouter de nouvelles clauses. Toute modification doit être réalisée par un nouvel acte établi par le notaire."
  },
  {
    "question": "Quelle est la différence entre un PACS en mairie et un PACS chez le notaire ?",
    "answer": "Un PACS en mairie est gratuit mais standardisé, sans conseils personnalisés.\n\nUn PACS chez le notaire offre une rédaction sur mesure, une sécurité juridique renforcée, et une conservation de l'acte.\n\nIl est particulièrement recommandé en cas de patrimoine conséquent ou de situations complexes."
  },
  {
    "question": "Le PACS donne-t-il droit à une protection en cas de décès ?",
    "answer": "Le PACS n'ouvre pas automatiquement de droits successoraux.\n\nCependant, en passant par un notaire, il est possible de prévoir des clauses de protection (occupation du logement, legs par testament, etc.)."
  },
  {
    "question": "Faut-il être de nationalité française pour conclure un PACS chez le notaire ?",
    "answer": "Non, le PACS est ouvert aux couples de même sexe ou de sexe différent, sans condition de nationalité.\n\nCependant, si un partenaire est étranger, certains documents spécifiques (acte de naissance étranger, certificat de coutume) peuvent être exigés."
  }
  ];

function Faq() {
  return (
    <section className="mt-10">
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-6  lg:px-8 ">
        <div className="mx-auto max-w-4xl">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Questions les plus fréquentes au sujet du PACS chez le notaire
          </h2>
          <dl className="mt-16 divide-y divide-gray-900/10">
            {faqs.map((faq) => (
              <Disclosure key={faq.question} as="div" className="py-6 first:pt-0 last:pb-0">
                <dt>
                  <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                    <span className="text-base/7 font-semibold">{faq.question}</span>
                    <span className="ml-6 flex h-7 items-center">
                      <PlusSmallIcon aria-hidden="true" className="size-6 group-data-open:hidden" />
                      <MinusSmallIcon aria-hidden="true" className="size-6 group-not-data-open:hidden" />
                    </span>
                  </DisclosureButton>
                </dt>
                <DisclosurePanel as="dd" className="mt-2 pr-12">
                  <p className="text-base/7 text-gray-600">{faq.answer}</p>
                </DisclosurePanel>
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
    </section>
  );
}

export default Faq;
